module.exports = __webpack_public_path__ + "img/deluxe-vehicles-filter-welcome-background-toyota.ba715fd0.png";